import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import Text from '@redbubble/design-system/src/Text';
import { useIntl } from '@redbubble/next/intl';
import { useRouter } from 'next/router';
import { messages } from './messages';
import styles from './SubscribeBanner.module.scss';

export const SubscribeBanner: React.FC = () => {
  const intl = useIntl();
  const router = useRouter();

  const handleClick = () => {
    router.push('/signup');
  };

  return (
    <div className={styles.container}>
      <Box
        className={styles.subscriberContainer}
        data-testid="subscribe-banner"
      >
        <Box className={styles.textContent}>
          <Text className={styles.title}>
            {intl.formatMessage(messages.member)}
          </Text>
          <Text className={styles.title}>
            {intl.formatMessage(messages.discount)}
          </Text>
          <Text className={styles.content}>
            {intl.formatMessage(messages.content)}
          </Text>
        </Box>
        <Box className={styles.buttonWrapper}>
          <Button
            intent={constants.PRIMARY}
            aria-label={intl.formatMessage(messages.signUp)}
            onClick={handleClick}
            strong
          >
            <Text type="display5" className={styles.buttonLabel}>
              {intl.formatMessage(messages.signUp)}
            </Text>
          </Button>
        </Box>
      </Box>
    </div>
  );
};
